import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 28 Mar 2026 22:35 PM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.c204lc45c1pbsx8tZ8uVo4BQBpRCbnKQ5vi6A6pyjDOUitFPE0J9feTIK_hApEILPG_E2203l5OZanF2ATOOEwuN6F1TU95517i_aueAT4v7n3FAANVYBra0Ieb6LUJ86DJAJMYh21TFUndKAl7Oo1xkrlvWTddPRoMUsZ7pOs7zJiQiDnNZ7OhTTIzdX4Sl59L80VRQSrOL-mUIui6rfFJ4VptgQn9Bj3GywNV0BroOLSMuHg3UC49x84UaL2z3hPy182D2hNZzY17_Ezkm2JEiV1BGi9MYw98Kajhdx7QxkGAyfHDxjCVsHEw3uxp1Dl7gLaCUOkzFMfd5n1d03FGUk45Yt8jiNA",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-08-03T14:44:45.614045Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-03-28T21:34:45+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.c204lc45c1pbsx8tZ8uVo4BQBpRCbnKQ5vi6A6pyjDOUitFPE0J9feTIK_hApEILPG_E2203l5OZanF2ATOOEwuN6F1TU95517i_aueAT4v7n3FAANVYBra0Ieb6LUJ86DJAJMYh21TFUndKAl7Oo1xkrlvWTddPRoMUsZ7pOs7zJiQiDnNZ7OhTTIzdX4Sl59L80VRQSrOL-mUIui6rfFJ4VptgQn9Bj3GywNV0BroOLSMuHg3UC49x84UaL2z3hPy182D2hNZzY17_Ezkm2JEiV1BGi9MYw98Kajhdx7QxkGAyfHDxjCVsHEw3uxp1Dl7gLaCUOkzFMfd5n1d03FGUk45Yt8jiNA'

// {
//   "access_token": "v2.local.u1P8KYc-svvb4sEWH85HP1KppOqWeLCIaJqju-uKsh7hKiQcWN6MLuB_GvdvJZMJvtWZyaGj_cq4f2G2O_ayqgtRv_4acD0OjOUgqLgkeuolYbi4dxCYODXtmwuOTVDtOCIvWuF-vxrxcgu8Zx2ME7mVEw6ofHV_5RDUqEEsMEErle-FPzJz-q3m-U4SSxuw37jymEqN4DcrLzOcrckyq7-zcrPWaRpS253crXNaNqbVU_rB0SmR_g17m7BKTzWUdmR0RugyLq9kn2C27QZZ7MObsqb4-tWccGFl86Y8vqMQRG-je9y5n6PpLB3Eecp_d3QbjcEfOgupHP9INkW2qq-4KeYT",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-08-03T14:44:45.911052Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-03-28T21:36:19+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.u1P8KYc-svvb4sEWH85HP1KppOqWeLCIaJqju-uKsh7hKiQcWN6MLuB_GvdvJZMJvtWZyaGj_cq4f2G2O_ayqgtRv_4acD0OjOUgqLgkeuolYbi4dxCYODXtmwuOTVDtOCIvWuF-vxrxcgu8Zx2ME7mVEw6ofHV_5RDUqEEsMEErle-FPzJz-q3m-U4SSxuw37jymEqN4DcrLzOcrckyq7-zcrPWaRpS253crXNaNqbVU_rB0SmR_g17m7BKTzWUdmR0RugyLq9kn2C27QZZ7MObsqb4-tWccGFl86Y8vqMQRG-je9y5n6PpLB3Eecp_d3QbjcEfOgupHP9INkW2qq-4KeYT'

// {
//   "access_token": "v2.local.ftGTDbeFcHgUlNlOLQpX8XV5vG9RAqZq8_Z-rO7pOZqJ-7n0xmIS7h-uM-yQLF-ivSF03mUwGs4h0hP-XFPlgs1JR9rtUkFCtq72VK5edjfLier_xNPXQ-UcgAPaR6TQVBeF5zPMltT-eO_8xtCwjG7HEQrU_IFTHSsa3d6QbxA_63Ab5YsXDJhUnU0tUe688Oa3pVllw8TKaKgKNF7K0aegtnAlskpQk1Carg8xYmzVM9t7uTSP5hGA7od0Vwb6Me0fvcY1uGtgThUFPeN1FGBcKSxJlgDlgBeWa9OjvHd7AIASYxVwbcPTua2RoZIleRzBmeQyJN2YTiTTnkGH4pAbTDI",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-08-03T14:44:46.254159Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.ftGTDbeFcHgUlNlOLQpX8XV5vG9RAqZq8_Z-rO7pOZqJ-7n0xmIS7h-uM-yQLF-ivSF03mUwGs4h0hP-XFPlgs1JR9rtUkFCtq72VK5edjfLier_xNPXQ-UcgAPaR6TQVBeF5zPMltT-eO_8xtCwjG7HEQrU_IFTHSsa3d6QbxA_63Ab5YsXDJhUnU0tUe688Oa3pVllw8TKaKgKNF7K0aegtnAlskpQk1Carg8xYmzVM9t7uTSP5hGA7od0Vwb6Me0fvcY1uGtgThUFPeN1FGBcKSxJlgDlgBeWa9OjvHd7AIASYxVwbcPTua2RoZIleRzBmeQyJN2YTiTTnkGH4pAbTDI'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
